"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSourceFromTarget = void 0;
const connectors_1 = require("./connectors");
const replaceSpecialCharsWithDash = (input) => {
    return input.replace(/[ #$&`:<>[\]{}“+%@/;=?\\^|~',]/g, "-");
};
const getDefaultSourceFromTarget = (connectorType, target) => {
    switch (connectorType) {
        case connectors_1.ConnectorType.SystemElement:
            return null;
        case connectors_1.ConnectorType.CsvToDynamo:
        case connectors_1.ConnectorType.WebServiceApi:
        case connectors_1.ConnectorType.CustomLambda:
            return Object.assign({}, target);
        case connectors_1.ConnectorType.QueryParams:
            return { name: replaceSpecialCharsWithDash(target.name), type: target.type };
        case connectors_1.ConnectorType.Dummy:
        default:
            return { name: "", type: target.type };
    }
};
exports.getDefaultSourceFromTarget = getDefaultSourceFromTarget;
//# sourceMappingURL=getDefaultSourceFromTargetUtils.js.map